
async function fetchHTML(product) {
    const parser = new DOMParser();

    const result = await fetch(`/products/${product
        }?section_id=bogo-cart-slider`).then(response => response.text()).then(data => parser.parseFromString(data, 'text/html'));

    return result;
};

async function loadBOGO() {
    if (document.querySelector('#bogoJSON')) {
        const productHandles = JSON.parse(document.querySelector('#bogoJSON').innerText);

        const asyncRes = await Promise.all(productHandles.map(async (product) => {
            let response = await fetchHTML(product.handle);

            let HTML = `
        <div class="Grid__Cell 1/1--phone 1/2--tablet 1/1--lap-and-up">
        <h2 class="SectionHeader__Heading Heading u-h4">${product.headline}</h2>
        ${response.querySelector('.grab-inner').innerHTML}
        </div>`;

            return HTML
        }))

        asyncRes.map(html => {
            document.querySelector('.BOGO--grid').innerHTML += html
        })
    }
}

async function fetchRecommendations(product, limit) {

    let result;
    let productIds = [];

    result = await fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${product}&limit=${limit}&intent=complementary`)
        .then(response => response.json())
        .then(({ products }) => { productIds = [...productIds, ...products]; }
        )

    if (productIds.length < limit) {
        result = await fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${product}&limit=${limit}&intent=related`)
            .then(response => response.json())
            .then(({ products }) => { productIds = [...productIds, ...products]; }
            )
    }

    return productIds.slice(0, limit);

}

async function renderCartRecommendations() {

    let array = [];

    const productsInCart = JSON.parse(document.querySelector('#productsInCart').value)
    let limit = Math.ceil(6 / productsInCart.length);


    await Promise.all(productsInCart.map(async (product) => {
        let response = await fetchRecommendations(product, 6);
        let firstElements = response.slice(0, limit)
        array = [...array, ...firstElements]
        return array.filter((v, i, a) => a.findIndex(v2 => (v2.id === v.id)) === i)
    }))


    const productHTML = await Promise.all(array.map(async (product) => {
        let response = await fetchHTML(product.handle);

        let HTML = `
            <div class="Grid__Cell 1/1--phone 1/2--tablet 1/1--lap-and-up">
            ${response.querySelector('.grab-inner').innerHTML}
            </div>`;

        return HTML;
    }))

    productHTML.map((html, index) => {
        if (index < 6) {
            document.querySelector('.cart--recommendations__container').innerHTML += html
        }
    })
}

async function renderProductRecommendations(product, limit) {

    const productRecommendations = await fetchRecommendations(product, limit);

    const productHTML = await Promise.all(productRecommendations.map(async (product) => {
        let response = await fetchHTML(product.handle);

        let HTML = `
        <div class="Carousel__Cell">
            ${response.querySelector('.grab-inner').innerHTML}
        </div>`


        return HTML;
    }))

    productHTML.map(html => {
        document.querySelector('.BOGO--carousel').innerHTML += html
    })
}


/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const pswpClickOutside = () => {

    // const pswpZoomWraps = document.querySelectorAll('.pswp__zoom-wrap');

    // if (pswpZoomWraps)
    // {
    //     pswpZoomWraps.forEach(pswpZoomWrap = () => {
    //         pswpZoomWrap.addEventListener('click', () => {
    //             document.querySelector('.pswp__button--close')?.click()
    //         })

    //     })
    // }
}


/**
 * 
 * Announcement bar
 * 
 */




const announcementBarWrapper = document.querySelector('[data-section-type="announcement-bar"] .AnnouncementBar__Wrapper');
if (announcementBarWrapper) {

    const barElems = announcementBarWrapper.querySelectorAll('.AnnouncementBar__Content');
    const sliderTime = document.querySelector('[data-section-type="announcement-bar"]').dataset?.sliderTime ? document.querySelector('[data-section-type="announcement-bar"]').dataset.sliderTime * 1000 : 5000



    let lastActive,
        currentActive,
        counter = 0,
        activeSlider = false;

    const setActive = (position) => {
        if (currentActive) {
            if (lastActive) {
                lastActive.classList.remove('last-active')
            }
            lastActive = currentActive;
            lastActive.classList.add('last-active')
            currentActive.classList.remove('active')
        }

        barElems[position].classList.add('active')
        currentActive = barElems[position]

        if (counter < barElems.length - 1) {
            counter = ++counter
        }
        else {
            counter = 0
        }
    }

    let interval = setInterval(() => { setActive(counter) }, sliderTime);
    const stopinterval = () => {
        clearInterval(interval);
    }

    window.addEventListener("resize", function () {
        if (window.matchMedia("(max-width: 641px)").matches) {
            if (!activeSlider) {
                activeSlider = true;
                interval = setInterval(() => { setActive(counter) }, sliderTime)
            }
        } else {
            activeSlider = false
            stopinterval()
        }
    })


    if (barElems) {
        if (window.matchMedia("(max-width: 641px)").matches) {
            activeSlider = true;
            setActive(counter);
        } else {
            activeSlider = false
            stopinterval()
        }
    }
}
const removeHiddenOnClick = (selector = '.js-remove-hidden') => {
    const elems = document.querySelectorAll(selector)

    if (elems) {
        elems.forEach(elem => {
            elem.addEventListener('click', (e) => {
                const sibling = e.target.nextElementSibling;
                if (sibling) {
                    if (sibling.classList.contains('is-hidden')) {
                        sibling.classList.remove('is-hidden');
                        e.target.remove();
                    }
                }
            })
        });
    }
}


/** Auto open first product tab */
const openFirstProductTab = () => {

    /** @type {HTMLElement} */
    const firstProductTab = document.querySelector('.Product__Tabs .Collapsible');
    if (firstProductTab) {
        /** @type {HTMLElement} */
        const firstProductTabButton = firstProductTab.querySelector('.Collapsible__Button');
        /** @type {HTMLElement} */
        const firstProductTabInner = firstProductTab.querySelector('.Collapsible__Inner');

        firstProductTab.classList.add('no-animate');


        firstProductTabButton.setAttribute("aria-expanded", true);
        firstProductTabInner.style.overflow = 'visible';
        firstProductTabInner.style.height = 'auto';

        setTimeout(() => {
            firstProductTab.classList.remove('no-animate');
        }, 500);
    }
}
openFirstProductTab();

document.addEventListener('DOMContentLoaded', function () {
    pswpClickOutside();
    removeHiddenOnClick();
}, false);



